module.exports = __webpack_public_path__ + "static/media/Top-3.701c1c87.webp";